module.exports = __webpack_public_path__ + "static/step-1-605416d160502ed8c79c01f462a976ae.svg";